export default () => {
  // do not translate case return error
  return <div>Global loading</div>;
};
